import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSGridModule } from '@norfolk-southern/accessns-components';

import { CarMovementInquiryEffects } from '@ruby/modules/unit-train/store/effects/car-movement-inquiry.effects';
import * as fromCarMovementInquiry from '@ruby/modules/unit-train/store/reducers/car-movement-inquiry.reducer';
import { DialogFooterModule } from '@ruby/shared/dialogs/dialog-footer/dialog-footer.module';
import { DialogHeaderModule } from '@ruby/shared/dialogs/dialog-header/dialog-header.module';
import { CarMovementInquiryDialog } from '@ruby/shared/dialogs/unit-train/car-movement-inquiry/components/car-movement-inquiry.dialog';
import { CarMovementInquiryContainer } from '@ruby/shared/dialogs/unit-train/car-movement-inquiry/containers/car-movement-inquiry.container';

@NgModule({
  declarations: [
    CarMovementInquiryDialog,
    CarMovementInquiryContainer
  ],
  imports: [
    CommonModule,
    DialogHeaderModule,
    DialogFooterModule,
    MatButtonModule,
    MatDialogModule,
    NSGridModule,
    EffectsModule.forFeature([CarMovementInquiryEffects]),
    StoreModule.forFeature(fromCarMovementInquiry.featureKey, fromCarMovementInquiry.reducer)
  ],
  exports: [CarMovementInquiryContainer]
})
export class CarMovementInquiryDialogModule {}
